/* T is for Tame · Build a Routine landing page (Round 13 R13-A5, spec round13-cro.md). Loaded only by sections/tame-lp-hero.
   The hero chips sit outside .tame-v3 (tame-v3.js binds its bottom bar to the first .tame-v3), so a tap here clicks the builder's
   own hidden chip: its preset() fills the kit and scrolls to it on phones, unchanged. This file only shows the matching review
   and keeps aria-pressed in step with the builder (it re-renders its chips on every change). The ?preset= state is set inline in
   the hero before first paint. No other behaviour. */
(() => {
  const row = document.querySelector('[data-lp-chips]');
  if (!row) return;
  const mine = Array.from(row.querySelectorAll('[data-preset]'));
  const own = Array.from(document.querySelectorAll('.tame-v3 .presets [data-preset]'));
  const rv = document.querySelector('[data-lp-rv]');
  const items = rv ? Array.from(rv.querySelectorAll('[data-rv-for]')) : [];
  const norm = (s) => (s === 'flyaways' ? 'bedhead' : s);
  const press = (slug) => mine.forEach((c) => c.setAttribute('aria-pressed', String(!!slug && c.dataset.preset === slug)));
  const show = (slug) => {
    const hit = items.find((f) => (' ' + f.dataset.rvFor + ' ').includes(' ' + slug + ' ')) || items[0];
    if (hit) items.forEach((f) => f.classList.toggle('is-on', f === hit));
  };
  row.addEventListener('click', (e) => {
    const c = e.target.closest('[data-preset]');
    if (!c) return;
    const slug = norm(c.dataset.preset);
    show(slug);
    press(slug);
    const t = own.find((o) => o.dataset.preset === slug);
    if (t) t.click();
    else if (window.TameBuilder && window.TameBuilder.preset) window.TameBuilder.preset(slug); // R13 QA fix: the intro band is out of the DOM
  });
  if (own.length && 'MutationObserver' in window) {
    const box = own[0].parentElement;
    new MutationObserver(() => {
      const on = own.find((o) => o.getAttribute('aria-pressed') === 'true');
      press(on ? on.dataset.preset : '');
    }).observe(box, { attributes: true, attributeFilter: ['aria-pressed'], subtree: true });
  }
})();
